import type { Resource } from '../../';
export const product_sizeChart_measurements_jp: Resource = {"default":"Japan"};
